<template>
    <section>
        <!-- -->
        <div class="mail-verif-wrapper elevation-5">
            <div class="hmi-cross">
                <img src="../../../assets/HMLOGO_WHITE.webp" alt="">
            </div>
            <div class="noti-content-wrapper">
                <div class="mail-svg">
                    <img src="../../../assets/mail-box.svg" alt="main-box">
                </div>
                <div class="noti" style="padding-bottom: 30px;">
                    <h2>An email has been sent!</h2>
                    <h3>
                        A reset link is sent to
                        <strong style="word-wrap: break-word;">{{ getRecoveryEmail }}</strong> to reset your password
                        and to fully use your account.
                    </h3>
                    <h4>
                        Didn't receive any mail? Check your spam folder or
                        <a href=""></a>
                        <v-btn
                            small
                            class="font-weight-bold"
                            text
                            :disabled="btn_disabled"
                            @click="
                                recoveryLink({
                                    MEMBN: $route.query.membn,
                                    EMAIL: getRecoveryEmail,
                                    RESET: true,
                                }),
                                btnSleep()
                            "
                        >
                            Click here
                        </v-btn>
                        to resend your activation link.
                        <br>
                    </h4>
                    <div v-if="btn_disabled" style="margin-bottom: 20px;">
                        Please wait for <span style="color: red;">{{ timer }}</span>s before resending the recovery link again.
                    </div>
                    <v-btn
                        color="#2DD682"
                        style="font-weight: 700;"
                        class="white--text"
                        @click="$router.push('/')"
                    >
                        done
                    </v-btn>
                </div>
            </div>
        </div>

    <!-- Skeleton -->
    </section>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
    data: () => ({
        url: 'https://www.google.com',
        btn_disabled: false,
        timer: 100
    }),
    computed: {
        ...mapGetters(['getRecoveryEmail'])
    },
    methods: {
        ...mapActions(['recoveryLink']),
        test() {
            alert('ok')
        },
        btnSleep() {
            this.btn_disabled = true
            this.timer = 100
            const interval = setInterval(() => {
                this.timer -= 1
                if(this.timer == 0) {
                    this.btn_disabled = false
                    clearInterval(interval)
                }
            }, 1000)
        }
    }
}
</script>

<style scoped>
section {
  background-image: url("../../../assets/loginBG.webp");
  background-position: center;
  background-size: cover;
  height: 100%;
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-direction: column;
}
h2 {
  font-size: 35px;
  padding: 15px 0px;
}
h3 {
  width: 90%;
  margin: auto;
  font-weight: normal;
}
h4 {
  width: 90%;
  margin: auto;
  padding: 20px 0px;
}
/* Main wrapper */
.hmi-cross {
  width: 5%;
  top: 2%;
  left: 1%;
}
.hmi-cross img {
  position: absolute;
  width: 100%;
}
.mail-verif-wrapper {
  position: relative;
  content: "";
  clear: both;
  display: table;
  height: auto;
  background-image: url("../../../assets/mail-bg-wrapper.webp");
  background-size: cover;
  background-position: center;
  background-color: white;
  border-radius: 100px 0px 100px 0px;
}
.mail-svg {
    margin: auto;
    width: 20%;
}
.mail-svg img {
    width: 20%;
}
.noti-content-wrapper {
  margin-top: 0;
  align-items: center;
  text-align: center;
}
.noti {
  margin: auto;
}
@media (max-width: 599px) {
  .mail-verif-wrapper {
    content: "";
    position: relative;
    clear: both;
    display: table;
    width: 90%;
    background-position: left;
    border-radius: 30px 0px 30px 0px;
  }
  .noti-content-wrapper {
    margin-top: 10px;
    width: 100%;
  }
  .noti {
    width: 90%;
  }
  .mail-svg {
    width: 50%;
    margin-top: 20px;
  }
  .mail-svg img {
    width: 30%;
  }
  .hmi-cross {
    position: absolute;
    width: 40%;
    left: 5%;
  }
  .hmi-cross img {
    width: 50%;
  }
  h2 {
    font-size: 25px;
  }
  h3 {
    font-size: 18px;
    padding: 15px 0px;
  }
  h4 {
    font-size: 15px;
  }
}
@media (min-width: 599px) and (max-width: 960px) {
  .mail-verif-wrapper {
    position: relative;
    content: "";
    clear: both;
    display: table;
    width: 90%;
    background-position: left;
    border-radius: 60px 0px 60px 0px;
  }
  .noti-content-wrapper {
    width: 100%;
  }
  .noti {
    width: 80%;
  }
  .hmi-cross {
    position: absolute;
    width: 30%;
    left: 5%;
  }
  .hmi-cross img {
    width: 50%;
  }
  .mail-svg {
    margin-top: 20px;
    width: 30%;
  }
  .mail-svg img {
    width: 50%;
  }
  h2 {
    display: block;
    font-size: 35px;
  }
  h3 {
    padding: 15px 0px;
  }
}
@media (min-width: 960px) and (max-width: 1263px) {
  .mail-verif-wrapper {
    position: relative;
    content: "";
    clear: both;
    display: table;
    width: 65%;
    background-position: left;
    border-radius: 60px 0px 60px 0px;
  }
  .noti-content-wrapper {
    width: 100%;
  }
  .noti {
    width: 80%;
  }
  .hmi-cross {
    position: absolute;
    width: 20%;
    left: 5%;
  }
  .hmi-cross img {
    width: 60%;
  }
  .mail-svg {
    margin-top: 5%;
    width: 40%;
  }
  .mail-svg img {
    width: 30%;
  }
  h2 {
    font-size: 40px;
  }
  h3 {
    padding: 15px 0px;
  }
}
@media (min-width: 1264px) {
  .mail-verif-wrapper {
    position: relative;
    content: "";
    clear: both;
    display: table;
    border-radius: 60px 0px 60px 0px;
  }
  .noti-content-wrapper {
  }
  .noti {
  }
  .hmi-cross {
    position: absolute;
    width: 20%;
    left: 5%;
  }
  .hmi-cross img {
    width: 50%;
  }
  .mail-svg {
    margin-top: 5%;
    width: 50%;
  }
  .mail-svg img {
    width: 20%;
  }
  h2 {
    font-size: 40px;
  }
  h3 {
    padding: 15px 0px;
  }
}
</style>
